import $ from 'jquery'
import _ from 'underscore'

$(function ($) {
  $('#cancelhead').on('click', function (event) {
    event.preventDefault()
    $('#cancel').slideToggle()
  })

  // Coupon search and deactivation
  const $coupon = $('#check-coupon')
  function couponResultsHandler(e) {
    e.preventDefault()

    function addColumn(target, input, isBefore) {
      let className = ''
      let text
      const now = new Date().getTime()

      if (typeof input === 'boolean') {
        text = input ? 'Yes' : 'No'
        className = input ? 'green' : 'error'
      } else if (typeof input === 'number') {
        const date = new Date(input)
        text = [
          date.getMonth() + 1,
          date.getDate(),
          date.getFullYear() - 2000
        ].join('/')
        if (isBefore) {
          className = input < now ? 'green' : 'error'
        } else {
          className = input < now ? 'error' : 'green'
        }
      } else {
        text = input
      }
      $(target).append('<td class=' + className + '>' + text + '</td>')
    }

    function addRow(target, className, rownum) {
      const id = className + '_' + rownum
      const $target = $(target)
      $target.append('<tr id="' + id + '" class="' + className + '"></tr>')
      return $target.find('#' + id)
    }

    function renderCouponsOrPromos(couponsOrPromos) {
      function toLocalTime(str) {
        const dd = Date.parse(str + ' UTC')
        if (isNaN(dd)) {
          return str
        } else {
          return new Date(dd).toString()
        }
      }

      function renderCouponOrPromo(couponOrPromo) {
        function isPromo(couponOrPromo) {
          return couponOrPromo.isPromo
        }

        function renderCoupon(coupon) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
          function deactivateCoupon(e) {
            const reason = prompt(
              'Why does this code need to be deactivated?'
            ).trim()
            if (!_.isEmpty(reason)) {
              $couponResult.html('Deactivating code...')
              const failText =
                '<div class="error">Oh snap! We couldn\'t deactivate the code <strong>' +
                code +
                "</strong>. You probably aren't logged in. Hit refresh!</div>"
              $.ajax({
                url: '/eco/csr/coupons/deactivate-code.json',
                data: {
                  code,
                  reason
                },
                type: 'post',
                dataType: 'json'
              })
                .done(function (success) {
                  if (success) {
                    $couponResult.html(
                      '<div class="green">Coupon code <strong>' +
                        code +
                        '</strong> deactivated successfully.</div>'
                    )
                  } else {
                    $couponResult.html(failText)
                  }
                })
                // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
                .fail(function (jqXHR, textStatus, error) {
                  $couponResult.html(failText)
                })
            } else {
              alert('Code deactivation canceled.')
            }
          }

          // eslint-disable-next-line no-var -- FIXME
          var $couponResult = $('<div class="coupon-result"></div>')

          $couponResult.html(
            '<div class="cr-name" style="text-decoration: underline;"></div>' +
              '<div>Code Active: <span class="cr-active"></span></div>' +
              '<div><a target="_blank" rel="noopener" href="#" class="dotted-bottom">Search Code in Gmail</a></div>' +
              (coupon.canBeDeactivated
                ? '<button class="small-space-top" style="margin-left: 0;">Deactivate Coupon</button>'
                : '') +
              '<div class="small-space-top"><strong>Details</strong></div>' +
              '<table id="couponResultTable">' +
              '<tr>' +
              '<th></th>' +
              '<th>Active</th>' +
              '<th>Start</th>' +
              '<th>End</th>' +
              '<th>Buy</th>' +
              '<th>Get</th>' +
              '<th>Last Used</th>' +
              '</tr>' +
              '</table>'
          )

          $couponResult.find('.cr-name').text(coupon.promo.promotionName)
          $couponResult
            .find('.cr-active')
            .text(coupon.active ? 'Yes' : 'No')
            .addClass(coupon.active ? 'green' : 'error')

          const couponTable = $couponResult.find('#couponResultTable')
          let row = 0
          _.each(coupon.promo.getBuyInfo, function (getBuy) {
            const couponResult = addRow(couponTable, 'cr-results-coupon', row)
            row = row + 1
            addColumn(couponResult, 'Coupon')
            addColumn(couponResult, coupon.couponActive)
            addColumn(couponResult, coupon.couponStartDate, true)
            addColumn(couponResult, coupon.couponEndDate, false)
            addColumn(couponResult, getBuy.buyString, false)
            addColumn(couponResult, getBuy.getString, false)
            addColumn(couponResult, toLocalTime(coupon.lastUsed), false)
          })

          const promoResults = addRow(couponTable, 'cr-results-promo', row)
          row = row + 1
          addColumn(promoResults, 'Promotion')
          addColumn(promoResults, coupon.promo.promotionActive)
          addColumn(promoResults, coupon.promo.promotionStartDate, true)
          addColumn(promoResults, coupon.promo.promotionEndDate, false)

          $couponResult
            .find('a')
            .attr(
              'href',
              'https://mail.google.com/a/paperculture.com/#search/label%3Areceipt+' +
                encodeURIComponent(code)
            )
          $couponResult.find('button').on('click', deactivateCoupon)
          $couponResults.append($couponResult)
        }

        function renderPromo(coupon) {
          const promo = coupon.promo
          // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
          function deactivatePromo(e) {
            const reason = prompt(
              'Why does this promo code need to be deactivated?'
            ).trim()
            if (!_.isEmpty(reason)) {
              $couponResult.html('Deactivating promo code...')
              const failText =
                '<div class="error">Oh snap! We couldn\'t deactivate the promo code <strong>' +
                code +
                "</strong>. You probably aren't logged in. Hit refresh!</div>"
              $.ajax({
                url: '/eco/csr/coupons/deactivate-promo-code.json',
                data: {
                  code,
                  reason
                },
                type: 'post',
                dataType: 'json'
              })
                .done(function (success) {
                  if (success) {
                    $couponResult.html(
                      '<div class="green">Promo code <strong>' +
                        code +
                        '</strong> deactivated successfully.</div>'
                    )
                  } else {
                    $couponResult.html(failText)
                  }
                })
                // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
                .fail(function (jqXHR, textStatus, error) {
                  $couponResult.html(failText)
                })
            } else {
              alert('Promo code deactivation canceled.')
            }
          }

          // eslint-disable-next-line no-var -- FIXME
          var $couponResult = $('<div class="coupon-result"></div>')

          $couponResult.html(
            '<div class="cr-name" style="text-decoration: underline;"></div>' +
              '<div>Code Active: <span class="cr-active"></span></div>' +
              '<div><a target="_blank" rel="noopener" href="#" class="dotted-bottom">Search Code in Gmail</a></div>' +
              '<div class="small-space-top"><strong>Details</strong></div>' +
              '<table id="promoResultTable">' +
              '<tr>' +
              '<th></th>' +
              '<th>Active</th>' +
              '<th>Start</th>' +
              '<th>End</th>' +
              '<th>Buy</th>' +
              '<th>Get</th>' +
              '<th>Last Used</th>' +
              '</tr>' +
              '</table>'
          )

          $couponResult.find('.cr-name').text(promo.promotionName)
          $couponResult
            .find('.cr-active')
            .text(promo.active ? 'Yes' : 'No')
            .addClass(promo.active ? 'green' : 'error')

          const promoTable = $couponResult.find('#promoResultTable')
          let row = 0
          _.each(promo.getBuyInfo, function (getBuy) {
            const promoResults = addRow(promoTable, 'cr-results-promo', row)
            row = row + 1
            addColumn(promoResults, 'Promotion')
            addColumn(promoResults, promo.promotionActive)
            addColumn(promoResults, promo.promotionStartDate, true)
            addColumn(promoResults, promo.promotionEndDate, false)
            addColumn(promoResults, getBuy.buyString, false)
            addColumn(promoResults, getBuy.getString, false)
            addColumn(promoResults, toLocalTime(coupon.lastUsed), false)
          })

          $couponResult
            .find('a')
            .attr(
              'href',
              'https://mail.google.com/a/paperculture.com/#search/label%3Areceipt+' +
                encodeURIComponent(code)
            )
          $couponResults.append($couponResult)
        }

        if (isPromo(couponOrPromo)) {
          renderPromo(couponOrPromo)
        } else {
          renderCoupon(couponOrPromo)
        }
      }

      // eslint-disable-next-line no-var -- FIXME
      var $couponResults = $('<div class="coupon-results"></div>')
      if (couponsOrPromos.length === 0) {
        $couponResults.html(
          '<div class="error">Coupon or Promo not found</div>'
        )
      }

      _.each(couponsOrPromos, renderCouponOrPromo)

      $couponResultOutput.html($couponResults)
    }

    // eslint-disable-next-line no-var -- FIXME
    var code = $coupon.find('input').val().trim()
    // eslint-disable-next-line no-var -- FIXME
    var $couponResultOutput = $('#check-coupon-results')
    $couponResultOutput.html('Processing...')

    $.ajax({
      url: '/eco/csr/coupons/check-code.json',
      data: {
        code
      },
      type: 'post',
      dataType: 'json'
    })
      .done(renderCouponsOrPromos)
      .fail(function (jqXHR, textStatus, errorThrown) {
        $couponResultOutput.html(
          '<div class="error">Oh snap! Your search didn\'t work. HTTP ' +
            textStatus +
            ' (' +
            jqXHR.status +
            ' ' +
            errorThrown +
            ')' +
            '</div>'
        )
      })
  }

  $coupon.submit(couponResultsHandler)
})

const $orderqueries = $('#orderqueries')
$orderqueries.on('click', function (event) {
  event.preventDefault()
  $.post('/eco/csr/emailorderqueries.html')
    .done(function () {
      $orderqueries.val('Success! Wait for it...').fadeOut('slow')
    })
    .fail(function () {
      $orderqueries.val('ERROR :(').fadeOut('slow')
    })
})
